import React from "react";
import { Box, Link, Typography } from "@bca/ui-library";

import SaleDateTimeBNBN from "./SaleDateTimeBNBN";
import MapMarkerSVG from "./Icons/MapMarkerSVG";

export interface SaleInformationBNBNProps {
  saleName: string;
  startDate: string;
  endDate: string;
  sectionName: string;
  localSaleLocation: string;
  saleLocationUrl: string;
  vehicleLocationDescription?: string;
}

const saleNameMapping = {
  "Bid Now": "Bid Now Sale",
  "Buy Now": "Buy Now Sale",
  "Bid Now Buy Now Exclusive": "Bid Now/Buy Now Sale",
};

const SaleInformationBNBN: React.FunctionComponent<SaleInformationBNBNProps> =
  ({
    saleName,
    startDate,
    endDate,
    sectionName,
    localSaleLocation,
    saleLocationUrl,
    vehicleLocationDescription,
  }) => {
    return (
      <Box
        width={
          saleName === "Bid Now" || saleName === "Buy Now" ? "280px" : "220px"
        }
        height="100%"
        marginBottom={["20px", 0]}
        marginRight="12px"
        marginTop={[0, 6, 6, 6]}
      >
        <Typography variant="h5" color="footer-blue" margin={0}>
          {saleNameMapping[saleName]}
        </Typography>
        <Box marginTop="6px" marginBottom={["17px", "10px"]}>
          <SaleDateTimeBNBN
            startDate={startDate}
            endDate={endDate}
          ></SaleDateTimeBNBN>
        </Box>
        <Box
          margin={0}
          display="flex"
          flexWrap="wrap"
          flexDirection={["column", "column", "row"]}
        >
          <Typography
            variant="h6"
            color="footer-blue"
            css="font-weight: 700;"
            marginRight={[0, 0, "34px"]}
            marginTop={0}
            marginBottom={2}
          >
            {sectionName}
          </Typography>
          <Box display="flex">
            <MapMarkerSVG fill="#060916" width="14px" height="18px" mr={3} />
            <Link
              color="primary-light-blue"
              underline="always"
              css="font-weight: 700;"
              href={saleLocationUrl}
              target="_blank"
              analytics={{
                eventLabel: `vehicle-location|${localSaleLocation}`,
                eventAction: `navigate`,
              }}
            >
              {localSaleLocation}
            </Link>
          </Box>
          {Boolean(vehicleLocationDescription) && (
            <Box display="flex" alignItems="center" marginTop={2}>
              <Typography variant="body-small" color="grey-blue" margin={0}>
                {vehicleLocationDescription}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    );
  };

export default SaleInformationBNBN;
